import { render, staticRenderFns } from "./staffLibrary.vue?vue&type=template&id=4afb4895&scoped=true"
import script from "./staffLibrary.vue?vue&type=script&lang=js"
export * from "./staffLibrary.vue?vue&type=script&lang=js"
import style0 from "./staffLibrary.vue?vue&type=style&index=0&id=4afb4895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb4895",
  null
  
)

export default component.exports